"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _timezones = _interopRequireDefault(require("./timezones.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var infoByValue = Object.keys(_timezones.default).reduce(function (values, group) {
  var options = _timezones.default[group];
  return _objectSpread({}, values, {}, options.reduce(function (acc, option) {
    return _objectSpread({}, acc, _defineProperty({}, option.value, {
      group: group,
      displayName: option.displayName
    }));
  }, {}));
}, {});

function Timezone(_ref) {
  var children = _ref.children;
  var info = infoByValue[children];
  return info ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", {
    className: "co-list__item-group-title"
  }, info.group, ":"), " ", info.displayName) : null;
}

Timezone.propTypes = {
  children: _propTypes.string.isRequired
};
var _default = Timezone;
exports.default = _default;
Timezone.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Timezone",
  "props": {
    "children": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  }
};